import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=7ed0ea8c&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=7ed0ea8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed0ea8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ed0ea8c')) {
      api.createRecord('7ed0ea8c', component.options)
    } else {
      api.reload('7ed0ea8c', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=7ed0ea8c&scoped=true&", function () {
      api.rerender('7ed0ea8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20f4MZMZR9awa/JS/comp/DocBox.vue"
export default component.exports